<template>
<div id="login" class="loginbg disableduser">
    <v-content>
     <v-layout> 
     <v-flex xs12>
             <img src="/static/loadmaxlogo.png" alt="LoadMax" height="40" class="lgImg">
            </v-flex>
             </v-layout> 
        <v-container fluid fill-height class="">
            <v-layout align-center justify-center> 
                <v-flex xs12 sm8 md3 lg3>
                    <v-card class="elevation-1 pa-3">
                        <v-card-text>
                            <div class="layout column signup">
                             <h1 class="flex">Welcome in LOADMAX</h1>
                             <p v-html="statusmessage"></p>
                            </div>
                            <v-form>
                               
                                <v-btn @click="logoutUser" block color="orange darken-1 white--text"> SIGN OUT</v-btn>
                                 

                                 <!-- </v-card-actions> -->
                            </v-form>
                        </v-card-text>
                      
                    </v-card>
                    <v-flex align-end class="text-md-center my-4 ">
                      <span class="calltxt">Questions? Call 1-866-925-6608</span>
                         </v-flex>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex";
import services from "../services/HttpService";
export default {
    data: () => ({
        statusmessage: 'disabled'
    }),
    mounted() {
        const self = this;
        
        setTimeout(function () {
        
        }, 1000);
        this.statusmessage = '';
        if(this.$store.state.user.status == 'pending'){
            this.statusmessage = "Thank you for registering for LOADMAX.You’re almost done!";
            this.statusmessage += '<br/>';
            this.statusmessage += 'Please give us 24 hours to verify your account before using LOADMAX. <br/>If you need immediate support, please call 1-866-925-6608 (9 AM-5 PM ET) or contact <a :mailto="support@loadmax.com">support@loadmax.com</a>.';
            this.statusmessage += '<br/>';
            this.statusmessage += 'LOADMAX. STAY LOADED.';

        }
        else if(this.$store.state.user.status == 'disabled'){
            this.statusmessage = "Your LOADMAX account has been disabled.";
            this.statusmessage += '<br/>';
            this.statusmessage += 'If you feel that this is an error or would like to talk to a LOADMAX support member, please call 1-866-925-6608 (9 AM-5 PM ET) or email <a :mailto="support@loadmax.com">support@loadmax.com</a>.'
        }
        else if(this.$store.state.user.status == 'cancelled'){
            this.statusmessage = "Your LOADMAX account has been canceled.";
            this.statusmessage += '<br/>';
            this.statusmessage += 'If you feel that this is an error or would like to renew your subscription, please contact the LOADMAX support team. Call 1-866-925-6608 (9 AM-5 PM ET) or email <a :mailto="support@loadmax.com">support@loadmax.com</a>.';
        }
    },
    methods: {
        ...mapActions([
            "logout"
        ]),
        logoutUser(){
            const self = this;
            if (confirm("Are you sure you want to logout?")) {
                self.logout();
                let loginUrl = '/login';
                if(self.$store.state.loginType && self.$store.state.loginType != ''){
                    loginUrl += '/'+self.$store.state.loginType;
                }
                self.$router.replace(loginUrl);
            }
        }
        
    }
};
</script>

<style lang="css" scoped>
#login {
    height:100%;
    width: 100%;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
    background-repeat: no-repeat;
    background-size: cover;
}
.disableduser h1,p{text-align:center;}
</style>



// WEBPACK FOOTER //
// src/pages/DisabledUser.vue